import { getRoot, IAnyStateTreeNode } from 'mobx-state-tree'

import type { IRoot } from '../types'

export const getRootStore = (node: IAnyStateTreeNode) => getRoot<IRoot>(node)
